import { formatAddress } from '~/lib/formatAddress'

import styles from './Account.pcss'

interface Props {
	address: string
	networkIcon?: string
}

export function Account({ address, networkIcon }: Props) {
	return (
		<div className={styles.container}>
			{!!networkIcon && (
				<div className={styles.iconContainer}>
					<img
						className={styles.icon}
						src={networkIcon}
						alt="active network icon"
					/>
				</div>
			)}

			<div className={styles.address}>
				{formatAddress({
					address,
					prefixLength: 6,
				})}
			</div>
		</div>
	)
}
